"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRootElement = void 0;
const react_1 = __importDefault(require("react"));
const react_google_login_1 = require("@cs125/react-google-login");
const element_tracker_1 = require("@cs125/element-tracker");
const mace_1 = require("@cs125/mace");
const jeed_1 = require("@cs125/jeed");
const chitter_1 = require("@cs125/chitter");
const runtypes_1 = require("runtypes");
const GOOGLE_CLIENT_ID = runtypes_1.String.check(process.env.GOOGLE_CLIENT_IDS).split(",")[0];
const ET_SERVER = process.env.ET_SERVER && runtypes_1.String.check(process.env.ET_SERVER);
const MACE_SERVER = process.env.MACE_SERVER && runtypes_1.String.check(process.env.MACE_SERVER);
const JEED_SERVER = process.env.JEED_SERVER && runtypes_1.String.check(process.env.JEED_SERVER);
const CHITTER_SERVER = process.env.CHITTER_SERVER && runtypes_1.String.check(process.env.CHITTER_SERVER);
console.log(`GOOGLE_CLIENT_ID: ${GOOGLE_CLIENT_ID}`);
ET_SERVER && console.log(`ET_SERVER: ${ET_SERVER}`);
MACE_SERVER && console.log(`MACE_SERVER: ${MACE_SERVER}`);
JEED_SERVER && console.log(`JEED_SERVER: ${JEED_SERVER}`);
CHITTER_SERVER && console.log(`CHITTER_SERVER: ${CHITTER_SERVER}`);
// eslint-disable-next-line react/prop-types
const WrapWithJeed = ({ idToken, children }) => JEED_SERVER ? (react_1.default.createElement(jeed_1.JeedProvider, { googleToken: idToken, server: JEED_SERVER }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
// eslint-disable-next-line react/prop-types
const WrapWithChitter = ({ idToken, children }) => CHITTER_SERVER ? (react_1.default.createElement(chitter_1.ChitterProvider, { googleToken: idToken, server: CHITTER_SERVER }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
exports.wrapRootElement = ({ element }) => {
    return (react_1.default.createElement(react_google_login_1.GoogleLoginProvider, { clientConfig: { client_id: GOOGLE_CLIENT_ID } },
        react_1.default.createElement(react_google_login_1.WithGoogleTokens, null, ({ idToken }) => (react_1.default.createElement(element_tracker_1.ElementTrackerServer, { server: ET_SERVER, googleToken: idToken },
            react_1.default.createElement(mace_1.MaceProvider, { server: MACE_SERVER, googleToken: idToken },
                react_1.default.createElement(WrapWithJeed, { idToken: idToken },
                    react_1.default.createElement(WrapWithChitter, { idToken: idToken }, element))))))));
};
//# sourceMappingURL=wrapRootElement.js.map